import { createI18n } from "vue-i18n";

function loadLocaleMessages() {
  const locales = require.context("./locales", true, /^\.\/[A-Z0-9_,-]+\.json$/i);
  const messages: { [key: string]: any } = {};
  for (const key of locales.keys()) {
    const matched = key.match(/^\.\/([A-Z0-9_-]+)\.json$/i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default || locales(key); // `.default` for ESM
    }
  }
  return messages;
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: sessionStorage.getItem("lang") || "English",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "English",
  messages: loadLocaleMessages()
});

export default i18n;
